export const SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};
//# sourceMappingURL=SelectorButton.constants.js.map